const styles = {
  root: {
    paddingBottom: 32,
    boxSizing: 'border-box',
  },
};

export default styles;
